import type {
  CoreClientFoodSharesCreateParams,
  CoreClientFoodSharesReadParams,
} from '../../types/core/methods';
import type {FoodShareApiModel} from './types';

import {EntityStore} from '../../utils/entityStore';

class FoodShareStore<
  T extends FoodShareApiModel = FoodShareApiModel,
> extends EntityStore<
  T,
  CoreClientFoodSharesReadParams,
  CoreClientFoodSharesCreateParams
> {}

export const foodShareStore = new FoodShareStore('food_share', {
  create: 'client.food_shares.create',
  fetch: 'client.food_shares.read',
});
